module.exports = __webpack_public_path__ + "static/media/silampos.a142ea40.webp";